import styled from "styled-components";
import {baseDistance, ELLIPSIS, FlexCenterStyle, fontSize, fontWeight, HEADER_HEIGHT, radius, VerticalFlexStyle} from "../../../../../styles/styles";
import {colorPalette} from "../../../../../styles/colorPalette";
import {TableHeadersStyled} from "../../../../../abstract/table/TableHeadersV5";
import {TableHeaderStyled} from "../../../../../abstract/table/TableHeaderV5";
import {TableCellStyled} from "../../../../../abstract/table/TableCellV5";
import {OuterTableCellStyled, TableRowStyled} from "../../../../../abstract/table/TableRowV5";

export const RunReportStyled = styled.div<{$isReportView: boolean}>`
	${VerticalFlexStyle};
	z-index: 8;
	top: ${HEADER_HEIGHT};
	bottom: 0;
	position: absolute;
	background: ${colorPalette.white};
	right: 0;
	border-radius: ${radius.md};
	left: 48px;
	font-size: ${fontSize.md};

	.header {
		display: flex;
		flex-direction: column;
		padding: ${baseDistance.md};
		gap: ${baseDistance.sm};
		padding: ${baseDistance.md};

		svg {
			cursor: pointer;
			width: ${baseDistance.md};
			height: ${baseDistance.md};
		}
	}

	.headerRow {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}

	.headerLeft {
		display: flex;
		align-items: center;
		gap: ${baseDistance.sm};
		flex: 1;

		.runReportButton {
			padding: 0 ${baseDistance.sm};
		}
	}

	.headerRight {
		display: flex;
		align-items: center;
		gap: ${baseDistance.sm};
		justify-content: flex-end;
		flex: 1;

		.archive-button {
			padding: 0 ${baseDistance.sm};
		}
	}

	.reportDescription {
		padding: ${baseDistance.sm};
		border-radius: ${radius.sm};
		max-width: 600px;
		height: 32px;
		line-height: 16px;
		display: block;
		color: ${colorPalette.gray.c700Dark};
		font-size: ${fontSize.md};
		${ELLIPSIS}
		cursor: pointer;

		&:hover {
			background-color: ${colorPalette.gray.c200Light};
		}
	}

	.SearchField {
		border: none;
	}

	.savebutton {
		background-color: ${colorPalette.primary.c500Primary};
		color: ${colorPalette.white};
	}

	.editReportButton {
		padding: 0 ${baseDistance.sm};
	}

	.lastReportRun {
		${FlexCenterStyle}
		font-size: ${fontSize.lg};
		border-radius: ${radius.sm};
		padding: ${baseDistance.sm};

		&.stale {
			color: ${colorPalette.white};
			background-color: ${colorPalette.warning.c500Primary};
		}
	}

	table {
		th:first-child,
		&.scrolled th:first-of-type {
			background-color: ${colorPalette.gray.c950};
		}

		tbody tr {
			background-color: ${colorPalette.gray.c100};

			&:hover:not(.isGrabbing) {
				background-color: ${colorPalette.gray.c200Light};
			}
		}

		${TableHeadersStyled} {
			color: ${colorPalette.gray.c200Light};
			background: ${colorPalette.gray.c950};

			${TableHeaderStyled}:hover {
				background-color: ${colorPalette.gray.c950};
			}
		}

		.tableWrapper {
			background-color: ${colorPalette.gray.c100};
		}
	}
`;

export const RunReportTableStyled = styled.div`
	${VerticalFlexStyle};
	flex: 1;
	min-height: 0;

	.module-Reports {
		margin-top: 0;
	}

	${TableRowStyled} {
		${OuterTableCellStyled} {
			${TableCellStyled} {
				padding-left: ${baseDistance.md};
			}

			&:first-child {
				${TableCellStyled} {
					padding-left: ${baseDistance.sm};
				}
			}
		}
	}
`;

export const DropDownTitleStyle = styled.div`
	padding: 0px ${baseDistance.sm};
	gap: ${baseDistance.sm};
	display: flex;
`;

export const ReportPopupStyled = styled.div`
	max-height: 516px;
	overflow: scroll;
`;

export const RunReportPageHeaderNameStyled = styled.div`
	${ELLIPSIS};
	max-width: 480px;
	font-size: ${fontSize.xl};
	font-weight: ${fontWeight.bold};
	line-height: 24px;
`;
